import {environment} from '../../environments/environment';

export class MicrosoftTeamsRecognitionService {

    public static isRunningWithinMicrosoftTeams(): boolean {
        return window.location.href.includes(environment.profileTabsUrl);
    }
}
